import { render, staticRenderFns } from "./PersonTaxableRebateRegEdit.vue?vue&type=template&id=77bdb896"
import script from "./PersonTaxableRebateRegEdit.vue?vue&type=script&lang=js"
export * from "./PersonTaxableRebateRegEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports